import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-progress-chart',
  templateUrl: './progress-chart.component.html',
  styleUrls: ['./progress-chart.component.css'],
})
export class ProgressChartComponent implements OnInit, OnDestroy {
  constructor() {}
  @Input() progress: any;
  @ViewChild('progressChart', { static: false }) progressChart: any;
  title: string = '';
  description: string = '';
  strokeColor: string = '';
  strokeDashoffset: number = 0;
  strokeWidth: number = window.innerWidth < 1441 ? 5 : 10;
  strokeDasharray: string = '';

  svgWidth: number = 200;
  svgHeight: number = 200;

  cx: number = 100;
  cy: number = 100;
  r: number = 80;

  secondStyle: boolean = false;
  colors: any = [
    {
      value: 49,
      getColor: () => {
        return this.secondStyle ? '#FF4548' : '#ff4548';
      },
    },
    {
      value: 89,
      getColor: () => {
        return this.secondStyle ? '#e29700' : '#fea307';
      },
    },
    {
      value: 100,
      getColor: () => {
        return this.secondStyle ? '#04CF6D' : '#04cf6d';
      },
    },
  ];

  backgroundColor: string = '';
  svgRotation: number = 0;

  valueFontSize: string = '';
  titleBottom: boolean = false;

  background_position_offset: any = '15px';

  ngOnInit() {
    // const boundUpdateProgress = this.updateFunction.bind(this);
    // window.addEventListener('resize', boundUpdateProgress);
  }
  ngOnDestroy(): void {
    // const boundUpdateProgress = this.updateFunction.bind(this);
    // window.removeEventListener('resize', boundUpdateProgress);
  }
  ngOnChanges() {
    this.updateFunction();
  }
  updateFunction() {
    if (this.progress?.title) this.title = this.progress.title;
    if (this.progress?.description)
      this.description = this.progress.description;
    if (isNaN(this.progress?.value)) this.progress.value = 0;
    this.strokeWidth = this.progress?.style?.strokeWidth
      ? this.progress.style.strokeWidth
      : window.innerWidth < 1441
      ? 5
      : 10;

    this.svgWidth = this.progress?.style?.width
      ? this.progress.style.width
      : window.innerWidth < 1441
      ? 140
      : 200;

    this.svgHeight = this.progress?.style?.height
      ? this.progress.style.height
      : window.innerWidth < 1441
      ? 140
      : 200;

    this.secondStyle = this.progress?.style?.secondStyle ? true : false;

    if (!this.progress?.style?.width) {
      if (window.innerWidth <= 375) {
        this.svgWidth = this.secondStyle ? 60 : 100;
        this.svgHeight = this.secondStyle ? 60 : 100;
      } else if (window.innerWidth < 440) {
        this.svgWidth = this.secondStyle ? 60 : 120;
        this.svgHeight = this.secondStyle ? 60 : 120;
      }
    }

    this.valueFontSize = this.progress?.style?.valueFontSize;
    this.titleBottom = this.progress?.style?.titleBottom;

    this.cx = this.svgWidth / 2;
    this.cy = this.svgHeight / 2;
    this.r = this.svgWidth / 2 - this.strokeWidth * 2;

    this.background_position_offset = this.strokeWidth * 1.5 + 'px';

    let circumference = 2 * Math.PI * this.r;

    this.strokeDasharray = `${circumference} ${circumference}`;

    this.strokeDashoffset = circumference;

    for (let i = 0; i < this.colors.length; i++) {
      if (this.progress.value <= this.colors[i].value) {
        this.strokeColor = this.colors[i].getColor();
        this.backgroundColor = this.colors[i].getColor();
        break;
      }
    }

    this.updateProgress();
  }
  updateProgress() {
    setTimeout(() => {
      const circle = this.progressChart.nativeElement;
      const radius = circle.r.baseVal.value;
      const circumference = radius * 2 * Math.PI;

      this.cx = this.svgWidth / 2;
      this.cy = this.svgHeight / 2;
      this.r = this.svgWidth / 2 - this.strokeWidth * 2;

      this.strokeDasharray = `${circumference} ${circumference}`;

      this.strokeDashoffset =
        circumference - (this.progress?.value / 100) * circumference;

      this.svgRotation = this.progress?.value * 3.6 - 5;
    }, 10);
  }
}
